<template>
  <div class="bg-light pt-150" style="min-height:875px">
    <div class="container">
      <div class="col">
        <div class="row">
          <div class="col-lg-4 m-hide">
            <img :src="$S3_url+'/Assets/images/login-left.png'" class="simgb" />
          </div>
          <div class="col-lg-4 p-5 bg-white mt-5 mb-5" style="box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.52)">
            <b-alert style="top: -93px;" variant="success" :show="showDismissibleAlert" v-if="!isMobile" dismissible><P class="mb-0 text-center" style="font-size:13px;opacity:0.7"><small>Successfully registered!</small></P><P class="mb-0 text-center" style="font-size:13px;opacity:0.9;"><small>{{ param_success_msg || 'You can login now.' }}</small></P></b-alert>
            <b-alert variant="success" :show="showDismissibleAlert" style="top:-50px;" v-if="isMobile" dismissible><P class="mb-0 text-center" style="font-size:13px;opacity:0.7"><small>Successfully registered!</small></P><P class="mb-0 text-center" style="font-size:13px;opacity:0.9;"><small>{{ param_success_msg || 'You can login now.' }}</small></P></b-alert>
            <h1 class="text-primary mb-4 text-center" style="font-size:1.5rem !important;">
              <strong>Employer login</strong>
            </h1>
            <form ref="login-form" @submit="PostRecruiterLogin">
              <div label-for="input-1">
                <v-text-field type="text" v-model="login.email" @input="validate.emailValidation(login.email, 'email')" @keydown.space.prevent  outlined><template #label>Email<span class="red--text"><strong>* </strong></span></template></v-text-field>
                <div class="error-feedback" v-if="typeof validate.response.email != 'undefined' && !validate.response.email.val">
                  {{ validate.response.email.msg }}
                </div>
              </div>

              <div label-for="login-password" class="mt-3">
                <v-text-field :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1" v-model="login.password" @input="validate.passwordValidation(login.password, 'password')" outlined><template #label>Password<span class="red--text"><strong>* </strong></span></template></v-text-field>
                <div class="error-feedback" v-if="(typeof validate.response.password != 'undefined' && !validate.response.password.val)">
                  {{ validate.response.password.msg }}
                </div>          
              </div>
              <div class="error-feedback" v-if="auth_error">{{error_msg}}</div>
              <div class="success-feedback" v-if="success_msg">{{success_msg}}</div>

              <b-form-group label-for="check-sign">
                <b-form-checkbox id="checkbox-1" name="checkbox-1" value="1" v-model="login.keep_me" unchecked-value="0" class="mt-3 text-secondary">
                  Keep me logged in | <a href="/recruit/request_password" class="flink"> Forgot password?</a>
                </b-form-checkbox>
              </b-form-group>
              <div class="text-center">
                <b-button type="submit" class="mr-3 text-center" variant="primary" v-if="!isSigning">Login</b-button>
                <b-button class="mr-3 mt-3 btn-signup"  style="cursor: no-drop;color:#fff !important;font-size:10px;" variant="primary" v-if="isSigning" disabled>Login...</b-button>
              </div>
            </form>
            <div class="col-lg-12 text-secondary mt-2 p-0 text-center sign_bottom">Not a member?<a href="/recruit/register" class="flink text-decoration-none"><h2 style="font-size:15px !important;"><strong> Create an account </strong></h2></a></div>
            <div class="col-lg-12 text-center"><small><a href="/recruit/privacy" target="noopener" class="flink text-decoration-none">Privacy Policy</a> | <a href="/recruit/terms" target="noopener" class="flink text-decoration-none"> Terms & Conditions</a></small>
            <div class="text-secondary">If you are Jobseeker? <a href="/" class="flink text-decoration-none"><strong> Click here.</strong></a></div>
          </div>
          </div>
          <div class="col-lg-4 m-hide">
            <img :src="$S3_url+'/Assets/images/login-right.png'" class="simga hideimg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      validate: new this.$valid(),
        login:{
          email:null,
          password:null,
          keep_me:0,
          src:null,
        },
      show1: false,
      errors: [],
      pass_error: false,
      auth_error:false,
      email_error: false,
      error_msg:'',
      moreinfo: false,
      validation: true,
      can_login:0,
      success_msg: false,
      isSigning:false,
      showDismissibleAlert: false,
      param_success_msg: '',
      isMobile : false
    };
  },
  beforeMount(){
    console.log(this.$route.params);
    if(this.$route.params.success_msg){
      this.showDismissibleAlert = true;
      this.param_success_msg = this.$route.params.success_msg;
    }
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      this.isMobile = true;
    }
  },
  methods:{
  checkFormValidity() {
    const valid = (this.login.email && this.login.password )? true : false;
    return valid;
  },
  PostRecruiterLogin: function(e){
    e.preventDefault();
    this.isSigning=true;
    this.email_error = false;
    this.auth_error = false;
    this.pass_error = false;
    this.can_login = 0;
    this.success_msg = false;

    if (this.validate.emailValidation(this.login.email, "email")?.val === false) {
      this.can_login++;
    }
    if (this.validate.passwordValidation(this.login.password, "password")?.val === false) {
      this.can_login++;
    }
    if (this.can_login === 0) {
      this.login.src = (this.$route.query.src)? this.$route.query.src: 'home-login';
      new this.$apiAction().employerLogin(this.login).then((res) => {
        this.isSigning=false;
        if([1, 2, 3, 4, 5, 6 ].includes(res.status))
        switch(res.status){
          case 1:
          case 2:
          case 4:
          case 5:
          case 6:this.auth_error = true; this.error_msg = res.message; break;
          case 3:this.auth_error = true; this.error_msg = 'Your account is not active. Please contact support.'; break;
          default:break;
        } else {
          if(res.token) {
            const employer = {token:res.token, name:res.name};
              this.$cookies.set("hire-employer", employer);
              if(this.$route.params.redirect_to) {
              this.$router.push({
                path: this.$route.params.redirect_to
              });
            } else {
              this.$router.push('/recruit/client-job-dashboard');
            }
              location.reload();
          }
        }
      }).catch((err) => {
        if(err){
          this.isSigning= false;
          this.auth_error = true;
          this.error_msg = 'Invalid Email or Password';
        }
      });
    }else{
      this.isSigning= false;
    }
  },
  }

}
</script>

<style>
.simgb{
  width: 350px;
  padding-top: 105px;
}
.simga{
      width: 455px;
    padding-top: 162px;
}
.pt-150
{
  padding-top:150px;
}

@media only screen and (max-width: 640px){
  .m-hide
  {
    display: none;
  }
  .pt-150
  {
    padding-top:150px;
  }
}
.alert-green{
  
}

.v-text-field__details{
  display: none !important;
}
.v-input__slot{
  margin-bottom: 0px !important;
} 
</style>
<style scoped>
.alert{position: absolute;width: 395px;margin-left: -4rem;}
</style>
